














import Vue from 'vue';
import banner from '@/components/common/banner/index.vue';
import menuBar from './menuBar.vue';
import history from './history.vue';
import marqueeBar from './marqueeBar.vue';
import fundBorad from './fundBorad.vue';
import searchBar from './searchBar.vue';

export default Vue.extend({
    name: 'home',
    components: {
        banner,
        menuBar,
        history,
        marqueeBar,
        fundBorad,
        searchBar
    }
});
